
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"62","height":"21","viewBox":"0 0 62 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.0391 6.97731C32.0046 9.69873 34.4644 11.2175 36.3174 12.1204C38.2213 13.0469 38.8608 13.641 38.8535 14.4694C38.839 15.7374 37.3348 16.297 35.9268 16.3188C33.4706 16.3569 32.0427 15.6557 30.9073 15.1252L30.0225 19.2655C31.1616 19.7905 33.2708 20.2483 35.4581 20.2683C40.5921 20.2683 43.9512 17.734 43.9694 13.8045C43.9894 8.81763 37.0714 8.54149 37.1186 6.3124C37.1349 5.63658 37.7799 4.91535 39.1933 4.73186C39.8927 4.63921 41.8239 4.56836 44.013 5.57663L44.8723 1.5708C43.695 1.14206 42.1817 0.731482 40.2978 0.731482C35.4654 0.731482 32.0663 3.3003 32.0391 6.97731ZM53.1292 1.07665C52.1918 1.07665 51.4015 1.62348 51.0491 2.4628L43.715 19.974H48.8454L49.8664 17.1527H56.1358L56.7281 19.974H61.2499L57.304 1.07665H53.1292ZM53.8468 6.18159L55.3274 13.2776H51.2725L53.8468 6.18159ZM25.8187 1.07665L21.7747 19.974H26.6635L30.7056 1.07665H25.8187ZM18.5864 1.07665L13.4978 13.9389L11.4395 3.00236C11.1979 1.78154 10.2441 1.07665 9.18496 1.07665H0.866279L0.75 1.6253C2.4577 1.9959 4.39794 2.59361 5.57335 3.23308C6.29276 3.62368 6.49804 3.96521 6.73421 4.89355L10.6329 19.974H15.7996L23.7204 1.07665H18.5864Z","fill":"#254AA5"}})])
          )
        }
      }
    